export const legalDocuments = {
  gdpr: 'https://drive.google.com/file/d/1vPD0t4Jl1WeifR4QLcmiNeBUh_pxX8_1/view',
  aszf: 'https://drive.google.com/file/d/1AHgVYNzt6z0v5wLyuL7KLTgMsyyUU3za/view?usp=sharing',
};
